import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { ADGMSelect, AccordionLayout } from 'aurora-components';

import styles from './styles';

/** ****************
Props Documentation:
--------------------
label : label of the filter
isAccordion: flag to check if accordion layout is required
customClasses: A object which contain custom classNames to override styles
otherSelectProps: all other adgmSelect props
***************** */

const FiltersSelect = ({ classes, isAccordion, label, customClasses, ...otherSelectProps }) => {
  if (isAccordion) {
    return (
      <AccordionLayout title={label}>
        <CustomFiltersSelect
          classes={classes}
          customClasses={{
            label: classes.label,
            select: classes.select,
            selected: classes.selected,
            dropdown: classes.dropdown,
            ...customClasses,
          }}
          {...otherSelectProps}
        />
      </AccordionLayout>
    );
  }

  return (
    <CustomFiltersSelect
      classes={classes}
      label={label}
      customClasses={{
        label: classes.label,
        select: classes.select,
        selected: classes.selected,
        dropdown: classes.dropdown,
        ...customClasses,
      }}
      {...otherSelectProps}
    />
  );
};

const CustomFiltersSelect = ({ classes, name, value, options, multi, onChange, ...otherSelectProps }) => {
  const onClickHandler = itemVal => {
    const updatedValues = value?.filter(curVal => curVal !== itemVal);
    onChange && onChange(name, updatedValues);
  };

  const onChangeHandler = (ddName, data) => {
    if (!data) {
      onChange && onChange(ddName, multi ? [] : null);
      return;
    }
    const newValue = multi ? data?.map(item => item?.value) : data?.value;
    onChange && onChange(ddName, newValue);
  };

  return (
    <div className={classes.container}>
      <ADGMSelect
        name={name}
        value={value}
        options={options}
        multi={multi}
        onChange={onChangeHandler}
        {...otherSelectProps}
      />
      {multi && isArray(options) && !isEmpty(options) && isArray(value) && !isEmpty(value) ? (
        <div className={classes.selectedItemsContainer}>
          {options
            ?.filter(option => value?.includes(option?.value))
            ?.map(item => (
              <div key={item?.value} className={classes.selectedItem}>
                <Typography variant='subtitle1' className={classes.selectedItemLabel}>
                  {item?.label}
                </Typography>
                <Icon className={classes.cancelIcon} onClick={() => onClickHandler(item?.value)}>
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <g clipPath='url(#clip0_1190_3175)'>
                      <path
                        d='M13.725 4.28251C13.4325 3.99001 12.96 3.99001 12.6675 4.28251L9.00004 7.94251L5.33254 4.27501C5.04004 3.98251 4.56754 3.98251 4.27504 4.27501C3.98254 4.56751 3.98254 5.04001 4.27504 5.33251L7.94254 9.00001L4.27504 12.6675C3.98254 12.96 3.98254 13.4325 4.27504 13.725C4.56754 14.0175 5.04004 14.0175 5.33254 13.725L9.00004 10.0575L12.6675 13.725C12.96 14.0175 13.4325 14.0175 13.725 13.725C14.0175 13.4325 14.0175 12.96 13.725 12.6675L10.0575 9.00001L13.725 5.33251C14.01 5.04751 14.01 4.56751 13.725 4.28251Z'
                        fill='#130F26'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_1190_3175'>
                        <rect width='18' height='18' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </Icon>
              </div>
            ))}
        </div>
      ) : null}
    </div>
  );
};

FiltersSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  isAccordion: PropTypes.bool,
  multi: PropTypes.bool,
  customClasses: PropTypes.object,
};

FiltersSelect.defaultProps = {
  isAccordion: false,
  multi: false,
  customClasses: {},
};

CustomFiltersSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  multi: PropTypes.bool.isRequired,
};

CustomFiltersSelect.defaultProps = {
  value: null,
  label: '',
};

export default withStyles(styles)(FiltersSelect);
